import axios from 'axios';
import { IRestClient, RestClient } from 'services/clients/RestClient';
import { IRequestHeader } from 'services/driverPortal/AuthenticationService.interface';
import {
  ImageLoadResult,
  PotentialLeadData,
  StatusData,
} from './MainService.interface';

class NotFound extends Error {}

const baseURL = process.env.REACT_APP_VMP_URL || '';

export class MainService {
  private restClient: IRestClient;
  private leadInfoRequest: Promise<PotentialLeadData> | null = null;

  constructor() {
    this.restClient = new RestClient({
      baseURL,
    });
  }

  private buildRequestHeaders(req: IRequestHeader) {
    const headers: Record<string, string> = { Accept: 'application/json' };
    if (req.responseType) headers.responseType = req.responseType;
    return headers;
  }

  async getInfo() {
    if (!this.leadInfoRequest) {
      this.leadInfoRequest = this.restClient
        .get<PotentialLeadData>('/api/rider/lead-info', {
          withCredentials: true,
        })
        .finally(() => {
          this.leadInfoRequest = null;
        });
    }

    return this.leadInfoRequest;
  }

  async getProfile(tel: string) {
    const path = '/api/getProfile';
    return this.restClient.post<PotentialLeadData>(path, {
      withCredentials: true,
      data: {
        email: tel,
      },
    });
  }

  async updateStatusCode(userId?: string, statusCode?: string) {
    void userId;

    const path = '/api/rider-status/save-potential-lead-status';
    return this.restClient.post<StatusData>(path, {
      data: {
        slaStatusCode: statusCode,
        updateBy: null,
      },
    });
  }

  async loadImage(pathFile: string) {
    const path = `/api/rider/download/rider-docs/${pathFile}`;
    const data = await this.restClient.get<Blob>(path, {
      headers: {
        'Content-Type': 'application/octet-stream',
      },
    });

    return new Blob([data], { type: 'blob' });
  }

  async loadImageAxios(
    src: string,
    timeoutMs = 15000,
  ): Promise<ImageLoadResult> {
    const res = await axios.get<ArrayBuffer>(
      `${baseURL}/api/rider/download/${src}`,
      {
        responseType: 'arraybuffer',
        timeout: timeoutMs,
        withCredentials: true,
        headers: {
          Accept: 'image/*',
        },
      },
    );

    const mimeType =
      (res.headers['content-type'] as string) || 'application/octet-stream';
    const blob = new Blob([res.data], { type: mimeType });
    const url = URL.createObjectURL(blob);

    return { blob, url, mimeType, size: blob.size };
  }
}
